/* Featured-product mini slider inside the nav drawer. Flex plus native
   scroll-snap plus scrollBy, matching every other carousel in this theme.

   The progress bar is measured, not guessed: the reference draws a 213x2
   grey rail with a 64x2 black thumb whose length is the visible fraction of
   the track. That has to be recomputed when the drawer opens, because while
   the panel is hidden the track reports a client width of zero and every
   ratio comes out wrong. */
(function () {
  function init(root) {
    if (root.dataset.upNavsliderReady) return;
    root.dataset.upNavsliderReady = '1';
    var track = root.querySelector('[data-up-navslider-track]');
    var bar = root.querySelector('[data-up-navslider-progress]');
    var prev = root.querySelector('[data-up-navslider-prev]');
    var next = root.querySelector('[data-up-navslider-next]');
    if (!track) return;

    function step() {
      var card = track.querySelector('li');
      if (!card) return track.clientWidth;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      if (!bar) return;
      var client = track.clientWidth;
      var total = track.scrollWidth;
      if (!client || !total) return;            // panel still hidden
      var visible = Math.min(client / total, 1);
      var max = total - client;
      var ratio = max > 0 ? track.scrollLeft / max : 0;
      bar.style.width = (visible * 100).toFixed(2) + '%';
      bar.style.marginInlineStart = (ratio * (1 - visible) * 100).toFixed(2) + '%';
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    // Recompute once the panel actually has a width.
    var drawer = root.closest('[data-up-drawer]');
    if (drawer && 'ResizeObserver' in window) {
      new ResizeObserver(update).observe(track);
    }
    if (drawer) {
      new MutationObserver(function () {
        if (!drawer.hidden) requestAnimationFrame(update);
      }).observe(drawer, { attributes: true, attributeFilter: ['hidden', 'class'] });
    }
    update();
  }

  function boot() { document.querySelectorAll('[data-up-navslider]').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();
